import { render, staticRenderFns } from "./gameTask.vue?vue&type=template&id=30cdda08&scoped=true&"
import script from "./gameTask.vue?vue&type=script&lang=js&"
export * from "./gameTask.vue?vue&type=script&lang=js&"
import style0 from "./gameTask.vue?vue&type=style&index=0&id=30cdda08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cdda08",
  null
  
)

export default component.exports